export const templatesKeys = {
  all: ['templates'] as const,
  list: (...args: unknown[]) => [...templatesKeys.all, 'list', ...args] as const,
  item: (id: string) => [...templatesKeys.all, 'item', id] as const,
};
